import React from 'react';
import TableWrapper from '../elements/TableWrapper';
import moment from "moment";

import {
    Row} from 'antd';
class DocumentComment extends React.Component {

    constructor(props) {
        super(props);
        this.Commentscolumn = [
            {
                title: 'Comments',
                dataIndex: 'comments',
                sorter: (a, b) => a.comments.localeCompare(b.comments),
                sortDirections: ["descend", "ascend"]
            },
            {
                title: 'Added By',
                dataIndex: 'name',
                sorter: (a, b) => a.name.localeCompare(b.name),
                sortDirections: ["descend", "ascend"]
            }, {
                title: 'Added On',
                dataIndex: 'comments_on',
                sorter: (a, b) => new Date(a.uploaded_on) - new Date(b.uploaded_on),
                render: (text, record) =>
                    record["uploaded_on"] !== null && record["uploaded_on"] !== ""
                        ? moment(record["uploaded_on"]).format("MM/DD/YYYY")
                        : "",
                sortDirections: ["descend", "ascend"]
            },  ];
        this.doccolumns = [
            {
                title: 'Name',
                dataIndex: 'document_Name',
                sorter: (a, b) => a.document_Name.localeCompare(b.document_Name),
                sortDirections: ["descend", "ascend"]
            },
            {
                title: 'Added By',
                dataIndex: 'name',
                sorter: (a, b) => a.name.localeCompare(b.name),
                sortDirections: ["descend", "ascend"]
            }, {
                title: 'Added On',
                dataIndex: 'uploaded_on',
                sorter: (a, b) => new Date(a.uploaded_on) - new Date(b.uploaded_on),
                render: (text, record) =>
                    record["uploaded_on"] !== null && record["uploaded_on"] !== ""
                        ? moment(record["uploaded_on"]).format("MM/DD/YYYY")
                        : "",
                sortDirections: ["descend", "ascend"]
            },  {
                title: 'Action',
                dataIndex: 'unq_Document_Name',
                render: (text, record) => {
                    return (
                        <div style={{ display: 'flex' }}>
                            <i style={{ marginTop: '10px' }} onClick={() => window.open(record["unq_Document_Name"], "_blank")} className="fa fa-eye fa-b" />
                        </div>
                    );
                },
            }];

    }


    render() {

        return (<>
         <Row span={24} style={{ marginBottom: '10px' }}>
                        <TableWrapper columns={this.Commentscolumn} rowKey="id" data={ this.props.commentsDtos}  title="Comments" search={true} />

         </Row>
               <Row span={24} style={{ marginBottom: '10px' }}>
               <TableWrapper columns={this.doccolumns} rowKey="id" data={ this.props.docDtos}  title="Documents" search={true} />
                            </Row ></>
        );
    }
}
export default DocumentComment;